import { createI18n } from "vue-i18n";
import { vuetifyLocaleMap } from './vuetify-generated.js';

/**
 * Load locale messages
 *
 * The loaded `JSON` locale messages is pre-compiled by `@intlify/vue-i18n-loader`, which is integrated into `vue-cli-plugin-i18n`.
 * See: https://github.com/intlify/vue-i18n-loader#rocket-i18n-resource-pre-compilation
 */
function loadLocaleMessages() {
    const modules = import.meta.glob("./**/*.json", { eager: true, import: "default" });
    const messages = {};
    for (const path in modules) {
        const match = path.match(/\/([A-Za-z0-9-_]+)\.json$/i);
        if (match) {
            const locale = match[1];
            messages[locale] = modules[path];
        }
    }
    // Integrate Vuetify translations
    for (const localeKey of Object.keys(messages)) {
        const base = localeKey.split('-')[0];
        const vuetifyMsg = vuetifyLocaleMap[localeKey] || vuetifyLocaleMap[base];
        if (vuetifyMsg) {
            messages[localeKey] = { $vuetify: vuetifyMsg, ...messages[localeKey] };
        }
    }
    return messages;
}
const dateTimeFormats = {
  en: {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
  },
  "it-IT": {
    short: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
  },
};
export default createI18n({
  legacy: false,
  locale: localStorage.getItem('lang') || 'en',
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
  dateTimeFormats,
});
